import { useEffect } from 'react';

export function useLifecycle({ onMount, onUnmount }: { onMount?: () => void; onUnmount?: () => void }) {
  useEffect(() => {
    onMount?.();
    return onUnmount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
